export const SPEC_SUB_TITLE_ENGINE_AND_TRANSMISSION = 'Engine & Transmission';
export const SPEC_SUB_TITLE_MEASUREMENT = 'Measurement';
export const SPEC_SUB_TITLE_ELECTRIC_MOTOR = 'Electric Motor';
export const SPEC_SUB_TITLE_PERFORMANCE = 'Performance';
export const SPEC_SUB_TITLE_SUSPENSION_BRAKES_WHEELS = 'Suspension, Brakes & Wheels'; // @suppress longLineCheck
export const SPEC_ITEM_TITLE_ENGINE_CAPACITY = 'Engine Capacity';
export const SPEC_ITEM_TITLE_BATTERY_TYPE = 'Battery Type';
export const SPEC_ITEM_TITLE_ENGINE_TYPE = 'Engine Type';
export const SPEC_ITEM_TITLE_FUEL_TYPE = 'Fuel Type';
export const SPEC_ITEM_TITLE_DRIVE_TYPE = 'Drive Type';
export const SPEC_ITEM_TITLE_TRANSMISSION = 'Transmission';
export const SPEC_ITEM_TITLE_VEHICLE_TYPE = 'Vehicle Type';
export const SPEC_ITEM_TITLE_SEATING_CAPACITY = 'Seating Capacity';
export const SPEC_ITEM_TITLE_DIMENSIONS = 'Dimensions (L x W x H)';
export const SPEC_ITEM_TITLE_WHEELBASE = 'Wheelbase';
export const SPEC_ITEM_TITLE_MIN_TURNING_RADUIS = 'Min Turning Radius';
export const SPEC_ITEM_TITLE_KERB_WEIGHT = 'Kerb Weight';
export const SPEC_ITEM_TITLE_FUEL_TANK_CAPACITY = 'Fuel Tank Capacity';
export const SPEC_ITEM_TITLE_BOOT_CARGO_CAPACITY = 'Boot/Cargo Capacity';
export const SPEC_ITEM_TITLE_POWER = 'Power';
export const SPEC_ITEM_TITLE_ENGINE_POWER = 'Engine Power';
export const SPEC_ITEM_TITLE_MOTOR_POWER = 'Motor Power';
export const SPEC_ITEM_TITLE_COMBINED_POWER = 'Combined Power';
export const SPEC_ITEM_TITLE_TORQUE = 'Torque';
export const SPEC_ITEM_TITLE_ACCELERATION = 'Acceleration';
export const SPEC_ITEM_TITLE_TOP_SPEED = 'Top Speed';
export const SPEC_ITEM_TITLE_FUEL_CONSUMPTION = 'Fuel Consumption';
export const SPEC_ITEM_TITLE_CO2_EMISSION = 'CO2 Emission';
export const SPEC_ITEM_TITLE_CO2_EMISSION_LTA = 'CO2 Emission (LTA)';
export const SPEC_ITEM_TITLE_SUSPENSION_FRONT = 'Suspension (Front)';
export const SPEC_ITEM_TITLE_SUSPENSION_REAR = 'Suspension (Rear)';
export const SPEC_ITEM_TITLE_BRAKES_FRONT = 'Brakes (Front)';
export const SPEC_ITEM_TITLE_BRAKES_REAR = 'Brakes (Rear)';
export const SPEC_ITEM_TITLE_RIM_SIZE = 'Rim Size';
export const SPEC_ITEM_TITLE_BATTERY_CAPACITY = 'Battery Capacity';
export const SPEC_ITEM_TITLE_DRIVE_RANGE = 'Drive Range';
export const SPEC_ITEM_TITLE_ENERGY_CONSUMPTION = 'Energy Consumption';
export const SPEC_ITEM_TITLE_AC_CHARGE_RATE = 'AC Max Charging Rate';
export const SPEC_ITEM_TITLE_AC_CHARGE_TIME = 'AC Charging Time';
export const SPEC_ITEM_TITLE_DC_CHARGE_RATE = 'DC Max Charging Rate';
export const SPEC_ITEM_TITLE_DC_CHARGE_TIME = 'DC Charging Time';
